import { PackageSubLOBProps } from "components/flexComponents/WizardPackagePWA/typings";
import * as React from "react";
import { observer } from "mobx-react";
import { Dates } from "src/components/shared/Dates/Dates";
import {
  UitkLayoutConditionalGridSpan,
  UitkLayoutGridItem,
  UitkLayoutGrid,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { MultiCityFlightLeg } from "../../WizardFlightPWA/components/MultiCityFlightLeg";
import { UitkTertiaryButton } from "uitk-react-button";
import { locKeys as locKeysFlight } from "components/flexComponents/WizardFlightPWA/components/l10n";
import { locKeys } from "../l10n";
import { StaySomewhereElse } from "./StaySomewhereElse";

export const PackageMulticityFlight = observer((props: PackageSubLOBProps) => {
  const addLegColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const fssseColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const datesHotelColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 8 };
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 2, medium: 12 };

  const { isFlightHotelMultiFormValid, updateInvalidFormsState } = props.packageWizardState;

  if (isFlightHotelMultiFormValid) {
    updateInvalidFormsState();
  }

  return (
    <>
      <UitkLayoutGrid columns={mainGridColumns} space="three">
        <MultiCityFlightLeg
          lobState={props.packageWizardState}
          routeStore={props.routeStore}
          showSwapLocationsControl={true}
        />

        {props.packageWizardState.listOfAdditionalLegs.length <
          props.packageWizardState.config.multiCityFlight.maxNumberOfAdditionalLegs && (
          <UitkLayoutGridItem colSpan={addLegColSpan}>
            <div>
              <UitkTertiaryButton
                icon="add"
                text={props.l10n.formatText(locKeysFlight.addFlightLabel)}
                onClick={props.packageWizardState.addALeg}
              />
            </div>
          </UitkLayoutGridItem>
        )}

        <UitkLayoutGridItem colSpan="all">
          <h2 className="uitk-type-heading-600">{props.l10n.formatText(locKeys.hotelSectionLabel)}</h2>
        </UitkLayoutGridItem>

        <StaySomewhereElse lobState={props.packageWizardState} colSpan={fssseColSpan} />

        <Dates lobState={props.packageWizardState} isPartialStay={true} colSpan={datesHotelColSpan} />
      </UitkLayoutGrid>
    </>
  );
});
